import React from 'react';

function Features() {
  const features = [
    {
      icon: '🏘️',
      title: 'آلاف العقارات',
      description: 'شقق، منازل، أراضي، مكاتب، ومحلات تجارية. كل ما تحتاجه من عقارات في مكان واحد'
    },
    {
      icon: '🔍',
      title: 'بحث ذكي ومتقدم',
      description: 'ابحث بسهولة عن عقارك المثالي باستخدام فلاتر متقدمة حسب المدينة، السعر، المساحة، ونوع العقار'
    },
    {
      icon: '🤝',
      title: 'تواصل مباشر',
      description: 'تواصل مباشرة مع أصحاب العقارات دون وسطاء، وفّر الوقت والمال واحصل على أفضل الصفقات'
    },
    {
      icon: '📱',
      title: 'منصة متكاملة',
      description: 'تطبيق موبايل متكامل، استخدم AWA من أي مكان وفي أي وقت'
    },
    {
      icon: '✅',
      title: 'إعلانات موثوقة',
      description: 'جميع الإعلانات تخضع للمراجعة لضمان جودتها ومصداقيتها'
    },
    {
      icon: '🚀',
      title: 'سريع وسهل الاستخدام',
      description: 'واجهة بسيطة وسهلة، انشر إعلانك أو ابحث عن عقارك في ثوانٍ'
    }
  ];

  return (
    <section id="features" className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-awa-dark mb-4">
            لماذا تختار منصة <span className="text-awa-green">AWA</span>؟
          </h2>
          <p className="text-lg text-awa-gray max-w-2xl mx-auto">
            نقدم لك منصة عقارية شاملة تجمع بين البائع والمشتري مباشرة
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="text-5xl mb-4">{feature.icon}</div>
              <h3 className="text-xl font-bold text-awa-dark mb-3">{feature.title}</h3>
              <p className="text-awa-gray leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;
